module.exports = __webpack_public_path__ + "img/img22.c40e0a9b.png";